<template>
  <Modal
    v-model="visible"
    :title="title"
    :mask-closable="false"
    :closable="false"
    :width="width"
    class-name="betch-import"
    @on-visible-change="bindGetData"
  >
    <span>每行一个标签（通过回车换行），支持黏贴多行文本添加标签词</span>
    <Input
      v-model="labels"
      type="textarea"
      style="width: 488px; margin: 4px 0"
      :autosize="{ minRows: 8, maxRows: 9 }"
      placeholder="每行一个标签（通过回车换行），支持黏贴多行文本添加标签词"
    />
    <p>
      <span
        >已输入标签<span :class="{ 'g-error-text': rows > length }">{{ rows }}</span
        >/<span>{{ length }}</span></span
      >
    </p>

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { isArray, isEmpty, trim } from '@/common/js/utils'
import { batchKeywordAction, batchKeywordInterest } from '@/api/toutiao.model'
export default {
  name: 'betchImport',
  props: {
    value: {
      type: Boolean
    },
    action: {
      type: Boolean
    },
    account: {
      type: [Number, String]
    },
    data: {
      type: Array
    },
    max: {
      type: [Number, String]
    },
    result: {
      type: Array,
      require: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$set('input', val)
      }
    },
    title() {
      return `批量添加${this.action ? '行为' : '兴趣'}`
    },
    len() {
      return this.result.length
    },
    length() {
      return this.max - this.len
    },
    rows() {
      return isEmpty(this.labels) ? 0 : this.labels.split(/\r?\n/).filter((ret) => trim(ret)).length
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.labels = ''
      }
    },
    async ok() {
      const _tags = this.labels
        .split(/\r?\n/)
        .map((ret) => trim(ret))
        .filter((ret) => !isEmpty(ret))

      // 去重
      const tags = [...new Set(_tags)]
      const repeatNum = _tags.length - tags.length

      // 验证
      if (isArray(tags) && tags.length > this.length) {
        this.$Message.error(`输入的标签数超过了最大数${this.length}`)
        return
      } else if (isArray(tags) && !tags.length) {
        this.$Message.error('输入的标签数不能为空！')
        return
      } else if (!isArray(tags)) {
        this.$Message.error('输入的标签数不合法！')
        return
      }
      const vaildTags = tags.filter((ret) => {
        const resTags = this.result.findIndex((met) => met.name === ret) > -1
        const idx = this.data.findIndex((met) => met.name === ret)
        return !resTags && idx > -1 && !this.data[idx].check
      })
      const failTags = tags.filter((ret) => {
        const resTags = this.result.findIndex((met) => met.name === ret) > -1
        const includeTags = this.data.findIndex((met) => met.name === ret) < 0
        const charT = ret.includes('/')
        return !charT && !resTags && includeTags
      })
      const submitTags = vaildTags.map((ret, id) => {
        const shift = this.data.filter((met) => met.name === ret).shift()
        if (shift.id === '0') Object.assign(shift, { type: 'KEYWORD', key: 'keyword', children: undefined })
        else Object.assign(shift, { type: 'CATEGORY' })
        return shift
      })
      if (isArray(failTags) && failTags.length) {
        let betchTags = null
        if (this.action) {
          // 行为关键词校验
          betchTags = await batchKeywordAction({
            adAccountId: this.account,
            queryWords: failTags,
            actionDays: '30',
            actionScene: 'E-COMMERCE,NEWS,APP'
          })
        } else {
          // 兴趣关键词校验
          betchTags = await batchKeywordInterest({
            adAccountId: this.account,
            queryWords: failTags
          })
        }
        if (isArray(betchTags)) {
          const submitBetch = betchTags.map((ret) => {
            ret.type = 'KEYWORD'
            ret.key = 'keyword'
            return ret
          })
          submitTags.push(...submitBetch)
        }
      }
      const errTags = tags.filter((ret) => submitTags.findIndex((met) => met.name === ret) < 0).join(',')
      this.$Modal.info({
        title: '系统消息',
        width: this.width,
        content: `<span>批量导入成功 <span style="color: #19be6b">${submitTags.length}</span>  个，失败  <span style="color: #ed4014"> ${
          tags.length - submitTags.length + repeatNum
        } </span>  个 </span>${
          errTags
            ? `<p style="max-height:315px;overflow-y:auto;scrollbar-width:thin;-webkit-overflow-scrolling:touch;"> 失败词为：${errTags}`
            : ''
        } </p>`
      })
      this.$emit('on-select', submitTags)
    }
  },
  data() {
    return {
      labels: '',
      width: 720
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .betch-import {
  span {
    line-height: 26px;
  }

  .ivu-modal-body {
    padding: 6px 15px;
  }
}
</style>
